import {
  fetchDashboardExperience,
  type DashboardExperienceResponse,
  updateDashboardExperienceOrder,
  type UpdateDashboardExperienceOrderRequest,
} from '@library/api-dashboard-experience'
import React from 'react'
import { useSWRConfig } from 'swr'

import { ApiKeys } from '../configs'

type UseUpdateDashboardOrderResult = {
  isUpdating: boolean
  updateOrder: (params: {
    orderId: string
    body: UpdateDashboardExperienceOrderRequest
  }) => Promise<DashboardExperienceResponse | undefined>
}

const useUpdateDashboardOrder = (): UseUpdateDashboardOrderResult => {
  const { mutate } = useSWRConfig()
  const [isUpdating, setIsUpdating] = React.useState(false)

  const updateOrder = React.useCallback(
    async ({ orderId, body }: { orderId: string; body: UpdateDashboardExperienceOrderRequest }) => {
      setIsUpdating(true)

      try {
        await updateDashboardExperienceOrder({ orderId, body })

        const refreshedDashboardExperience = await fetchDashboardExperience()

        await mutate(ApiKeys.DashboardExperience, refreshedDashboardExperience, {
          populateCache: true,
          revalidate: false,
        })

        return refreshedDashboardExperience
      } finally {
        setIsUpdating(false)
      }
    },
    [mutate],
  )

  return {
    isUpdating,
    updateOrder,
  }
}

export { useUpdateDashboardOrder }
